<template>
  <div>
    <!-- {{ appState.isColorPicking }}=={{ currentColor }} -->
    <div class="straw cursor-pointer" :class="{ actived: isPicking }" @click.stop="startPick">
      <img class="" width="14" src="@/assets/straw.svg" />
    </div>
    <teleport to="body">
      <div class="color-circle" :class="[showCircle ? 'circle' : 'text']" v-if="isPicking" :style="circleStyle">
        <span class="txt">移至图片取色</span>
      </div>
    </teleport>
  </div>
</template>

<script setup>
import { computed, nextTick, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { sendLog } from '@/utils/sentry';

const emit = defineEmits(['ok']);

const store = useStore();
const appState = computed(() => store.state.app);
const isStorePicking = computed(() => appState.value.isColorPicking);
const currentColor = ref('');
const circleSize = 60;
const showCircle = ref(false);
const circlePosition = ref({});
const isPicking = ref(false);

const circleStyle = computed(() => {
  const { x, y } = circlePosition.value;
  return { left: x - circleSize + 'px', top: y - circleSize + 'px', borderColor: currentColor.value };
});
const onOver = e => {
  showCircle.value = true;
};
const onOut = () => {
  showCircle.value = false;
  currentColor.value = '';
};

let $canvasMask = document.querySelector('.color-picking-mask');
let isErrorSended = false;
const onMove = e => {
  if (!$XJCanvas) return;
  // get the current mouse position
  // 不加这句的话，在笔刷模式下受_absolutePointer的影响mouse的xy值不变
  $XJCanvas._resetTransformEventData();
  const mouse = $XJCanvas.getPointer(e);
  const ctx = $XJCanvas.getContext('2d');
  const x = parseInt(mouse.x);
  const y = parseInt(mouse.y);
  // get the color array for the pixel under the mouse
  // 如果devicePixelRatio=2，则是4个点，目前先只取一个点，后面取点数的平均值
  let px = [];
  const dataParams = [x, y, 1, 1].map(fixCoords).map((i, idx) => {
    // 宽高不能小于1px，否则取不到值会报错：
    // IndexSizeError: Failed to execute 'getImageData' on 'CanvasRenderingContext2D': The source width is 0.
    if (idx === 2 || idx === 3) {
      return i < 1 ? 1 : i;
    } else {
      return i;
    }
  });
  // console.log(dataParams);
  try {
    px = ctx.getImageData(...dataParams).data;
  } catch (err) {
    if (!isErrorSended) {
      sendLog(`colorpicking:error,${dataParams}`);
    }
    isErrorSended = true;
  }
  // report that pixel data
  const [r, g, b, a] = px;
  // currentColor.value = `rgba(${r},${g},${b},${a})`;
  currentColor.value = `rgb(${r},${g},${b})`;
  // console.log(e.x, e.y);
  // console.log( mouse, x, y, currentColor.value);
};
const pointMove = e => {
  circlePosition.value = { x: e.x, y: e.y };
};
const dispose = () => {
  if (isStorePicking.value) {
    // sendLog('colorpicking:success');
  }
  isPicking.value = false;
  currentColor.value && emit('ok', currentColor.value);
  $XJCanvas.isDrawingMode = appState.value.isDrawingMode;
  if ($canvasMask) {
    $canvasMask.removeEventListener('mouseenter', onOver);
    $canvasMask.removeEventListener('mousemove', onMove);
    $canvasMask.removeEventListener('mouseleave', onOut);
    $canvasMask.removeEventListener('click', dispose);
  }
  window.removeEventListener('mousemove', pointMove);
  showCircle.value = false;
  store.commit('app/SET_COLOR_PICKING', false);
};
const startPick = e => {
  circlePosition.value = { x: e.x, y: e.y };
  isPicking.value = true;
  store.commit('app/SET_COLOR_PICKING', true);
  $XJCanvas.isDrawingMode = false;
  nextTick(() => {
    $canvasMask = document.querySelector('.color-picking-mask');
    if ($canvasMask) {
      $canvasMask.addEventListener('mouseenter', onOver);
      $canvasMask.addEventListener('mousemove', onMove);
      $canvasMask.addEventListener('mouseleave', onOut);
      $canvasMask.addEventListener('click', dispose);
    }
    window.addEventListener('mousemove', pointMove);
    // sendLog('colorpicking');
  });
};

function fixCoords(coord) {
  return coord * window.devicePixelRatio;
}

watch(isStorePicking, nv => {
  if (!nv) {
    dispose();
  }
});
</script>

<style lang="less" scoped>
.straw {
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 3px;
  text-align: center;
  &.actived,
  &:hover {
    background: #eee;
  }
}
.color-circle {
  position: fixed;
  width: 120px;
  height: 120px;
  line-height: 208px;
  border-width: 18px;
  border-style: solid;
  border-radius: 50%;
  pointer-events: none;
  text-align: center;
  z-index: 10;
  .txt {
    padding: 3px 6px;
    color: #fff;
    border-radius: 3px;
    background: rgba(0, 0, 0, 0.8);
  }
  &.text {
    border: 0 solid transparent !important;
    &:before,
    &:after {
      display: none;
    }
  }
  &.circle {
    .txt {
      display: none;
    }
  }
  &:before,
  &:after {
    content: '';
    position: absolute;
    left: -18px;
    top: -18px;
    right: -18px;
    bottom: -18px;
    border-radius: 50%;
    border: 2px solid #fff;
  }
  &:after {
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
  }
}
</style>
